import {
  BASE_HOME_URL,
  SIGNATURE_PAYMENTS_BASE_URL,
} from "../constants/constants";
import axios_ from "axios";
import MixPanel from "./mixpanel";
import FB from "./tracking/facebook";
import axios from "axios";
import { toast } from "react-toastify";
/*
 * createStripeOneTimePayment
 * @description: One-time payment with normal Stripe checkout
 */
let createStripeOneTimePayment = async (
  priceId,
  billing_action,
  plan,
  planCycle,
  amount,
  quantity = 1,
  email = ""

) => {
  try {
    let { data } = await axios_.post(
      `${SIGNATURE_PAYMENTS_BASE_URL}/createStripeOneTimePaymentUS`,
      {
        priceId: priceId,
        quantity: quantity,
        email: email,
        cancelUrl: window.location.href,
        successUrl: `https://www.boloforms.com/signature/deals/lifetime-purchase-done?value=${amount}&priceId=${priceId}&quantity=${quantity}&product=${plan}`,
      }
    );
    let { sessionUrl } = data;

    // facebook tracking
    new FB().trackInitiateCheckout(plan, priceId, quantity, amount);

    new MixPanel().track("Billing", {
      billing_action,
      plan,
      planCycle,
      amount,
    });
    new MixPanel().increment(billing_action);

    window.open(sessionUrl, "_self");
  } catch (error) {
    console.log(error);
  }
};

/*
 * redirectToStripeOneTimePayment
 * @description: One-time payment with custom Stripe checkout
 */
let redirectToStripeOneTimePayment = async ({
  priceId,
  billing_action,
  plan,
  planCycle,
  amount,
  quantity = 1,
  email = "",
}) => {
  const sessionUrl = `${BASE_HOME_URL}/payment-info?amount=${amount}&priceId=${priceId}&quantity=${quantity}&plan=${plan}&dealType=${planCycle}`;

  // facebook tracking
  new FB(email).trackInitiateCheckout(plan, priceId, quantity, amount);

  window.open(sessionUrl, "_self");
};

/*
 * createNormalStripeSubscription
 * @description: Subscription payment with normal Stripe checkout
 */
let createNormalStripeSubscription = async (
  priceId,
  billing_action,
  plan,
  planCycle,
  amount,
  quantity = 1,
  email
) => {
  try {
    let { data } = await axios_.post(
      `${SIGNATURE_PAYMENTS_BASE_URL}/createStripeSubscriptionUS`,
      {
        priceId: priceId,
        quantity: quantity,
        email: email,
        cancelUrl: window.location.href,
        successUrl: `https://www.boloforms.com/thank-you?value=${amount}&priceId=${priceId}&quantity=${quantity}&product=${plan}`,
      }
    );
    let { sessionUrl } = data;

    // facebook tracking
    new FB(email).trackInitiateCheckout(plan, priceId, quantity, amount);

    new MixPanel().track("Billing", {
      billing_action,
      plan,
      planCycle,
      amount,
    });
    new MixPanel().increment(billing_action);

    window.open(sessionUrl, "_self");
  } catch (error) {
    console.log(error);
  }
};

/*
 * createStripeSubscriptionUS
 * @description: Subscription payment with custom Stripe checkout
 */
let createStripeSubscriptionUS = async (
  priceId,
  billing_action,
  plan,
  planCycle,
  amount,
  quantity = 1,
  email
) => {
  try {
    // let { data } = await axios_.post(
    //   `${SIGNATURE_PAYMENTS_BASE_URL}/createStripeSubscriptionUS`,
    //   {
    //     priceId: priceId,
    //     quantity: quantity,
    //     email: email,
    //     cancelUrl: window.location.href,
    //     successUrl: `https://www.boloforms.com/thank-you?value=${amount}&priceId=${priceId}&quantity=${quantity}&product=${plan}`,
    //   }
    // );
    // let { sessionUrl } = data;

    const sessionUrl = `${BASE_HOME_URL}/payment-info?amount=${amount}&priceId=${priceId}&quantity=${quantity}&plan=${plan}`;

    // facebook tracking
    new FB(email).trackInitiateCheckout(plan, priceId, quantity, amount);

    // new MixPanel().track("Billing", {
    //   billing_action,
    //   plan,
    //   planCycle,
    //   amount,
    // });
    // new MixPanel().increment(billing_action);

    window.open(sessionUrl, "_self");
  } catch (error) {
    console.log(error);
  }
};


let createStripeSubscriptionUSWithTrial = async (
  priceId,
  trialPriceId,
  billing_action,
  plan,
  planCycle,
  amount,
  quantity = 1,
  email
) => {

  let { data } = await axios_.post(
    `${SIGNATURE_PAYMENTS_BASE_URL}/startTrialWithChargeSubscription`,
    {
      priceId: priceId,
      trialPriceId: trialPriceId,
      quantity: quantity,
      email: email,
      cancelUrl: window.location.href,
      successUrl: `https://www.boloforms.com/thank-you?value=${amount}&priceId=${priceId}&quantity=${quantity}&product=${plan}`,
    }
  );
  let { sessionUrl } = data;

  // facebook tracking
  new FB(email).trackInitiateCheckout(plan, priceId, quantity, amount);

  new MixPanel().track("Billing", {
    billing_action,
    plan,
    planCycle,
    amount,
  });
  new MixPanel().increment(billing_action);

  window.open(sessionUrl, "_self");

}

const createAPITierSubscriptions = async ({ documentsCount }) => {
  try {
    const ownerEmail = JSON.parse(localStorage.getItem("owner", "{}"))?.email;
    const { data } = await axios.post(
      `${SIGNATURE_PAYMENTS_BASE_URL}/createAPITierSubscriptionsUS`,
      {
        documentsCount,
        ownerEmail: ownerEmail,
        successUrl: window.location.toString(),
        cancelUrl: window.location.toString(),
      }
    );

    // new Tracking(ownerEmail).trackInitiateCheckout("API", data.priceId, 1, 20);

    if (data?.sessionUrl) {
      window.open(data?.sessionUrl, "_blank");
    } else {
      toast.error("No Checkout URL");
    }
  } catch (error) {
    console.log("Error in createAPITierSubscriptions ==> ", error);

    toast.error("Something went wrong");
  }
};


module.exports = {
  createStripeOneTimePayment,
  redirectToStripeOneTimePayment,
  createStripeSubscriptionUS,
  createNormalStripeSubscription,
  createStripeSubscriptionUSWithTrial,
  createAPITierSubscriptions,
};
